import * as React from 'react';

import Tooltip from '../Tooltip';

import { ToString } from '../../lib/utils';

class ReportType extends React.Component<ReportType.IProps, ReportType.IState> {
  render() {
    return (
      <div className={`report-type-container px-4 mx-auto ${ToString(this.props.className)}`} onClick={this._setValue}>
        <Tooltip message={ToString(this.props.message)} containerClassName="d-flex h-100">
          <label className={`eon-checkbox-label m-auto d-flex h-auto align-items-center ${ToString(this.props.className)}`}>
            {this.props.children}
            <h5 className="eon-title m-auto">{this.props.label}</h5>
          </label>
        </Tooltip>
      </div>
    );
  }

  _setValue = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();

    return (
      this.props.SetValue &&
      this.props.SetValue({
        currentTarget: { id: 'reportType', value: this.props.reportType },
        preventDefault: () => undefined
      } as React.ChangeEvent<HTMLInputElement>)
    );
  };
}

export default ReportType;
